module.exports = __webpack_public_path__ + "static/media/logoHTML5.502881ab.svg";